import { CountryCode } from '@src/common/auth';
import { useAppSelector } from '@src/core/hooks';

import { buyerSelector } from '@src/features/customers';

export const useBuyerCountryCode = (): CountryCode => {
  const [buyer] = useAppSelector(buyerSelector);

  return (buyer?.countryCode as CountryCode | undefined) ?? CountryCode.BRAZIL;
};

export default useBuyerCountryCode;
